import { createApp } from "vue";
import RecordingAddToList from "./RecordingAddToList.vue";
import { i18n } from '../../i18n';

// The recording page's "Add to list" button (#show-add-to-list-modal) opens a
// modal of the signed-in user's lists. Only rendered for signed-in viewers.
const appElement = document.getElementById('recording-add-to-list-app');
if (appElement) {
  const app = createApp(RecordingAddToList, {
    recordingId: appElement.getAttribute('data-recording-id') || '',
  });
  app.use(i18n);
  app.mount(appElement);
}
